import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Component } from 'react';
export class Button extends Component {
    constructor(props) {
        super(props);
        this.onMouseClick = this.onMouseClick.bind(this);
    }
    onMouseClick(event) {
        this.props.onClick(event);
        event.stopPropagation();
        event.preventDefault();
    }
    render() {
        if (!this.props.visible) {
            return null;
        }
        const { children, buttonStyle, additionalClass, onOver, onLeave, enabled, checked, tooltip, SVG, name, text, image } = this.props;
        const buttonClass = `terceraButton ${buttonStyle} ${additionalClass}`;
        return (_jsxs("div", { className: `${buttonClass}${!enabled ? ' disabled' : ''}${checked ? ' checked' : ''}`, onClick: this.onMouseClick, onMouseOver: onOver, onMouseLeave: onLeave, "data-tooltip": tooltip, children: [SVG && (_jsx("svg", { children: _jsx("use", { xlinkHref: `assets/webdesktop/web-desktop-sprite.svg#${name}` }) })), image && _jsx("div", { className: "icon", children: image }), text && _jsx("div", { className: "js-text", children: text }), children, !enabled && _jsx("div", { className: "js-disabled-icon" })] }));
    }
}
Button.defaultProps = {
    text: '',
    buttonStyle: 'js-button-gray25',
    checked: false,
    visible: true,
    enabled: true,
    additionalClass: ''
};
